import { api } from "./client";
import type { User } from "../types";

interface AuthResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export const authApi = {
  loginWithTelegram: (initData: string) =>
    api.post<AuthResponse>("/auth/telegram", { init_data: initData }, { skipAuth: true }),

  devLogin: () =>
    api.post<AuthResponse>("/auth/dev", {}, { skipAuth: true }),

  getMe: () => api.get<User>("/auth/me"),
};
